import type {
  CompliancePolicyId,
  ComplianceViolation,
  ComplianceViolationListInput,
  ComplianceViolationListSuccess,
  UserId,
} from '@terros/common'
import type { GetHookResponse } from '../../hooks'
import { complianceViolationsKey } from '../../keys'
import { useTantalimQuery } from '../../query'

export function useComplianceViolations(
  entityId?: CompliancePolicyId | UserId
): GetHookResponse<ComplianceViolation[]> {
  return useTantalimQuery<ComplianceViolationListInput, ComplianceViolationListSuccess, ComplianceViolation[]>({
    url: '/compliance/violation/list',
    queryKey: complianceViolationsKey(entityId),
    input: {
      entityId,
    },
    convertResponse: (data) => data.violations,
  })
}
